// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__ZGaqU","slider":"Switch_slider__heApS"};